import React from "react";
import { Icons } from "../../components/common/Icons";
import EmpWelcomeBanner from "./EmpWelcomeBanner";
import EmpAttendanceWidget from "./EmpAttendanceWidget";
import EmpLeaveSummaryWidget from "./EmpLeaveSummaryWidget";
import { useEmployeeData } from "../../context/EmployeeContext";
import { useEffect, useState } from "react";
import api from "../../services/api";import "../../assets/styles/Employee/EmpDashboardView.css";

function EmpDashboardView({ user }) {
  const { empInfo, empChecklist, empOnboardDocs, empNotifications, empAttendanceData, empLeaveSummary, empExperience, empPermBalance } = useEmployeeData();
  const [noticeMsg, setNoticeMsg] = useState("");

  useEffect(() => {
    api.getEmployeeLifecycleRequests('offboarding').then((rows) => {
      const active = (Array.isArray(rows) ? rows : []).find((r) => {
        if (!r.notice_start_date || !r.notice_end_date) return false;
        const now = new Date();
        const s = new Date(r.notice_start_date);
        const e = new Date(r.notice_end_date);
        return now >= s && now <= e;
      });
      if (active) {
        setNoticeMsg(`You are under notice period (${active.notice_start_date} to ${active.notice_end_date}).`);
      } else {
        setNoticeMsg("");
      }
    }).catch(() => setNoticeMsg(""));
  }, []);

  const att = empAttendanceData || {};
  const totalDays = att.totalDays || 0;
  const present = att.present || 0;
  const leaves = att.leaves || 0;
  const late = att.late || 0;
  const exp = empExperience || {};
  const expYears = exp.experience_months ? Math.floor(exp.experience_months / 12) : 0;
  const expMonths = exp.experience_months ? exp.experience_months % 12 : 0;
  const pb = empPermBalance || {};

  return (
    <>
      <EmpWelcomeBanner />
      {noticeMsg &&
      <div className="card animate-in mb-24 empdashboardview-inline-1">
          <div className="card-body empdashboardview-inline-2">{noticeMsg}</div>
        </div>
      }
      {empChecklist && empChecklist.length > 0 &&
      <div className="card animate-in delay-1 mb-24">
          <div className="card-header"><div className="card-title">Onboarding Checklist</div><div className="view-only-badge"><Icons.Eye /> View Only</div></div>
          <div className="card-body">{empChecklist.map((item, i) => <div className="checklist-item" key={i}><div className={`checklist-check ${item.done ? "done" : "pending"}`}>{item.done && <Icons.Check />}</div><div className={`checklist-label ${item.done ? "" : "pending"}`}>{item.label}</div></div>)}</div>
        </div>
      }
      <div className="grid-2 mb-24">
        <div className="card animate-in delay-2">
          <div className="card-header"><div className="card-title">Attendance</div><div className="card-subtitle">{new Date().toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })}</div></div>
          <div className="card-body">
            <div className="stats-grid-4">
              {[[totalDays, "Working", "#4f46e5"], [present, "Present", "#2563eb"], [leaves, "Leave", "#f59e0b"], [late, "Late", "#ef4444"]].map(([v, l, c], i) =>
              <div className="stat-item" key={i}><div className="stat-value empdashboardview-dyn-1" style={{ "--empdashboardview-1-color": c }}>{v}</div><div className="stat-label">{l}</div></div>
              )}
            </div>
          </div>
        </div>
        <EmpLeaveSummaryWidget />
      </div>
      <div className="grid-2 mb-24">
        <div className="card animate-in delay-3">
          <div className="card-header"><div className="card-title">Payroll</div><div className="card-subtitle">Jan 2026</div></div>
          <div className="card-body empdashboardview-inline-3">
            <div className="empdashboardview-inline-4">₹{empInfo.net}</div>
            <div className="empdashboardview-inline-5">Net Pay · Credited Jan 31</div>
          </div>
        </div>
        <div className="card animate-in delay-4">
          <div className="card-header"><div className="card-title">Performance</div><div className="card-subtitle">Last Review</div></div>
          <div className="card-body empdashboardview-inline-6">
            <div className="empdashboardview-inline-7">{[1, 2, 3, 4, 5].map((i) => <span key={i} style={{ "--empdashboardview-2-color": i <= 4 ? "#f59e0b" : "#e2e8f0" }} className="empdashboardview-dyn-2">{i <= 4 ? "★" : "☆"}</span>)}</div>
            <div className="empdashboardview-inline-8">4.5<span className="empdashboardview-inline-9">/5</span></div>
            <div className="empdashboardview-inline-10">Exceeds Expectations</div>
          </div>
        </div>
      </div>
      {/* Experience & Permission Balance Section */}
      <div className="grid-2 mb-24">
        <div className="card animate-in delay-5">
          <div className="card-header"><div className="card-title">Experience</div></div>
          <div className="card-body">
            <div className="stats-grid-4">
              {[
              [exp.joining_date ? new Date(exp.joining_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—', 'Joined', '#4f46e5'],
              [exp.experience_months ? `${expYears}y ${expMonths}m` : '—', 'Experience', '#2563eb'],
              [exp.designation || empInfo.role || '—', 'Role', '#2563eb'],
              [(exp.current_projects || []).length || 0, 'Active Projects', '#f59e0b']].
              map(([v, l, c], i) =>
              <div className="stat-item" key={i}><div className="stat-value empdashboardview-dyn-3" style={{ "--empdashboardview-3-color": c, "--empdashboardview-3-font-size": `${typeof v === 'string' && v.length > 6 ? 12 : 18}px` }}>{v}</div><div className="stat-label">{l}</div></div>
              )}
            </div>
            {(exp.current_projects || []).length > 0 &&
            <div className="empdashboardview-inline-11">
                {exp.current_projects.map((p, i) =>
              <div key={i} className="empdashboardview-inline-12">
                    <span className="empdashboardview-inline-13">{p.name}</span>
                    <span className="chip chip-ip empdashboardview-inline-14">{p.status}</span>
                  </div>
              )}
              </div>
            }
            {(exp.completed_projects || []).length > 0 &&
            <div className="empdashboardview-inline-15">
                {exp.completed_projects.slice(0, 3).map((p, i) =>
              <div key={i} className="empdashboardview-inline-16">
                    <span>{p.name}</span>
                    <span className="chip chip-ok empdashboardview-inline-17">Done</span>
                  </div>
              )}
              </div>
            }
          </div>
        </div>
        <div className="card animate-in delay-5">
          <div className="card-header"><div className="card-title">Permission Balance</div><div className="card-subtitle">This Month</div></div>
          <div className="card-body empdashboardview-inline-18">
            <div style={{ "--empdashboardview-4-color": pb.remaining > 2 ? "#2563eb" : "#ef4444" }} className="empdashboardview-dyn-4">
              {pb.remaining != null ? pb.remaining : '—'}<span className="empdashboardview-inline-19"> / {pb.total || '—'} hrs</span>
            </div>
            <div className="empdashboardview-inline-20">Remaining Permission Hours</div>
            {pb.used > 0 && <div className="empdashboardview-inline-21">{pb.used} hrs used this month</div>}
          </div>
        </div>
      </div>
      <div className="card animate-in delay-5">
        <div className="card-header"><div className="card-title">Notifications</div></div>
        <div className="card-body">{(empNotifications || []).length === 0 ?
          <div className="empdashboardview-inline-22">No notifications yet</div> :
          (empNotifications || []).slice(0, 6).map((n, idx) => {
            const fmtTime = (t) => {
              if (!t) return '';
              try {const d = new Date(t);const diff = Math.floor((Date.now() - d) / 60000);if (diff < 1) return 'Just now';if (diff < 60) return `${diff}m ago`;if (diff < 1440) return `${Math.floor(diff / 60)}h ago`;return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });}
              catch {return '';}
            };
            return (
              <div className="notif-item" key={n.id || idx}>
              <div className={`notif-dot${n.unread || !n.is_read ? " unread" : ""}`} />
              <div className="notif-content">
                <div className={`notif-text${n.unread || !n.is_read ? " unread" : ""}`}>{n.text || n.body || n.title || n.message || ''}</div>
                <div className="notif-meta">
                  <span>{fmtTime(n.time || n.created_at)}</span>
                  {n.type && <span className={`notif-type ${n.type}`}>{n.type}</span>}
                </div>
              </div>
            </div>);

          })}</div>
      </div>
    </>);

}

export default EmpDashboardView;